const REQUEST_DIGEST_PREFIX = "api-request:";

export class RequestError extends Error {
  readonly requestId: string | null;
  readonly digest?: string;
  readonly errorDetails: string | null;

  constructor(message: string, response?: Response) {
    const requestId = response?.headers.get("x-request-id") ?? null;
    super(requestId ? `${message}\nRequest ID: ${requestId}` : message);
    this.requestId = requestId;
    this.errorDetails = null;
    if (requestId && response) {
      // Next.js preserves digest when it sanitizes server-rendered error messages.
      this.digest = `${REQUEST_DIGEST_PREFIX}${encodeURIComponent(requestId)}`;
      const details = [
        `Request ID: ${requestId}`,
        `HTTP status: ${response.status}`,
        `Time: ${new Date().toISOString()}`,
      ];
      if (response.url)
        details.push(`Endpoint: ${new URL(response.url).pathname}`);
      this.errorDetails = details.join("\n");
    }
  }
}
